<ngx-spinner
  [name]="spinnerName"
  [type]="spinnerOption.type"
  [zIndex]="spinnerOption.zIndex"
  [fullScreen]="spinnerOption.fullScreen">
</ngx-spinner>
<ng-content></ng-content>
